"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeText = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const formatText = (text) => {
    const res = [];
    let isBold = false;
    const [openBold, closeBold] = ['{B}', '{/B}'];
    text.forEach(word => {
        if (!isBold) {
            if (word.includes(openBold)) {
                if (word.includes(closeBold)) {
                    res.push(react_1.default.createElement("b", null,
                        word.replace(openBold, '').replace(closeBold, ''),
                        " "));
                }
                else {
                    isBold = true;
                    res.push(react_1.default.createElement("b", null,
                        word.replace(openBold, ''),
                        " "));
                }
            }
            else {
                res.push(react_1.default.createElement(react_1.default.Fragment, null,
                    word,
                    " "));
            }
        }
        else {
            if (word.includes(closeBold)) {
                res.push(react_1.default.createElement("b", null,
                    word.replace(closeBold, ''),
                    " "));
                isBold = false;
            }
            else {
                res.push(react_1.default.createElement("b", null,
                    word,
                    " "));
            }
        }
    });
    return res;
};
const AttributeText = ({ onInteract, text, width, height, gameplayStyle: componentStyle, className, }) => {
    const textArr = text.split(' ');
    return (react_1.default.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: width ? `${width}` : '100%',
            height: height ? `${height}` : '100%',
        } },
        react_1.default.createElement(material_1.Typography, { onClick: () => {
                if (onInteract) {
                    onInteract();
                }
            }, className: `${className}-${componentStyle}` }, formatText(textArr))));
};
exports.AttributeText = AttributeText;
